import useParams from '../../../hooks/useParamsAndCookies';
import { CLAIM_STATUS, ClaimFiltersOptions } from './ClaimFilters';

const parseStatus = (value: string) =>
  CLAIM_STATUS.some((status) => status.value === value) ? value : undefined;

const ClaimParams = () => {
  useParams<ClaimFiltersOptions>({
    tab: 'CLAIM',
    params: [{ label: 'claimStatus', parse: parseStatus }],
    cookieFiltersName: 'insuranceFilters',
    cookiePath: '/insurance',
  });

  return <span />;
};

export default ClaimParams;
